import { mergeClassName as e } from "../../utils/data.js";
import { Banner as t } from "../Banner/Banner.js";
import { titleCase as n } from "../../utils/text.js";
import r from "./EnvironmentBanner.module.js";
import { Typography as i } from "../Typography/Typography.js";
import { useId as a, useState as o } from "react";
import { Fragment as s, jsxDEV as c } from "react/jsx-dev-runtime";
import { ArrowRightIcon as l, CaretDownIcon as u, EyeIcon as d } from "@phosphor-icons/react";
//#region lib/components/EnvironmentBanner/EnvironmentBanner.tsx
var f = "/opt/render/project/src/shared-ui/lib/components/EnvironmentBanner/EnvironmentBanner.tsx";
function p({ environment: p, productionUrl: m, className: h }) {
	let [g, _] = o(!1), v = a();
	if (!p || p === "production") return;
	let y = n(p), b = /* @__PURE__ */ c(s, { children: [
		/* @__PURE__ */ c(d, {
			size: 16,
			weight: "fill"
		}, void 0, !1, {
			fileName: f,
			lineNumber: 24,
			columnNumber: 13
		}, this),
		y,
		" mode"
	] }, void 0, !0, {
		fileName: f,
		lineNumber: 23,
		columnNumber: 9
	}, this);
	return /* @__PURE__ */ c(t, {
		backgroundColor: "info",
		"aria-label": `${y} mode`,
		className: e(r.banner, h),
		children: [
			/* @__PURE__ */ c(i, {
				weight: "medium",
				alignItems: "center",
				className: e(r.label, r.desktopLabel),
				children: b
			}, void 0, !1, {
				fileName: f,
				lineNumber: 35,
				columnNumber: 13
			}, this),
			/* @__PURE__ */ c("button", {
				type: "button",
				className: r.toggle,
				"aria-expanded": g,
				"aria-controls": v,
				onClick: () => {
					_(!g);
				},
				children: [/* @__PURE__ */ c(i, {
					weight: "medium",
					alignItems: "center",
					className: r.label,
					children: b
				}, void 0, !1, {
					fileName: f,
					lineNumber: 51,
					columnNumber: 17
				}, this), /* @__PURE__ */ c(u, {
					size: 16,
					className: r.caret
				}, void 0, !1, {
					fileName: f,
					lineNumber: 54,
					columnNumber: 17
				}, this)]
			}, void 0, !0, {
				fileName: f,
				lineNumber: 42,
				columnNumber: 13
			}, this),
			/* @__PURE__ */ c("div", {
				id: v,
				className: e(r.details, g && r.expanded),
				children: [/* @__PURE__ */ c(i, {
					paragraph: !0,
					className: r.message,
					children: [
						"You're in the ",
						y,
						" environment. All changes are for testing purposes only and won't affect real-world operations."
					]
				}, void 0, !0, {
					fileName: f,
					lineNumber: 57,
					columnNumber: 17
				}, this), /* @__PURE__ */ c("a", {
					className: r.link,
					href: m,
					children: [/* @__PURE__ */ c(i, { children: "Go to Production" }, void 0, !1, {
						fileName: f,
						lineNumber: 62,
						columnNumber: 21
					}, this), /* @__PURE__ */ c(l, { size: 16 }, void 0, !1, {
						fileName: f,
						lineNumber: 63,
						columnNumber: 21
					}, this)]
				}, void 0, !0, {
					fileName: f,
					lineNumber: 61,
					columnNumber: 17
				}, this)]
			}, void 0, !0, {
				fileName: f,
				lineNumber: 56,
				columnNumber: 13
			}, this)
		]
	}, void 0, !0, {
		fileName: f,
		lineNumber: 30,
		columnNumber: 9
	}, this);
}
//#endregion
export { p as EnvironmentBanner };
